import axios from 'axios';

// Public endpoints must not force-auth redirect, so anonymous users can see API errors in-place.
const publicClient = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
});

export default publicClient;
